import PublicLayout from "layout/PublicLayout";
import Error from "pages/Error/Error";
import React from "react";
import { Outlet } from "react-router-dom";

const Home = React.lazy(() => import("pages/home/Home"));
const Features = React.lazy(() => import("../pages/features/Features"));
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy"));

const pubilcRoutes = {
  path: "/",
  element: (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ),
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: "features",
      element: <Features />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "*",
      element: <Error />,
    }
  ],
};

export default pubilcRoutes;
